/** @format */

import React from 'react'
import styled from 'styled-components'
import { _$, Drawer, Button, Table, TableColumn } from '@king-design/react'
import { useAsync } from 'react-use'
import { getFunctionVersions } from 'src/api/ApiEventOpsFunction'
import UserInfo from 'src/components/UserInfo'
import { formatDate } from 'src/utils/date'
import { useHistory } from 'react-router-dom'
import { renderFunctionStatus } from '../utils'

interface VersionHistoryProps {
  className?: string
  visible: boolean
  record: any
  onClose: () => void
}

const VersionHistory: React.FC<VersionHistoryProps> = ({ className, visible, record, onClose }) => {
  const history = useHistory()

  const { value: versionList, loading } = useAsync(async () => {
    if (visible && record?.Sign) {
      const result = await getFunctionVersions(record.Sign)
      return result || []
    }
    return []
  }, [visible, record?.Sign])

  return (
    <Drawer
      title={_$('版本')}
      value={visible}
      width={1000}
      onChangeValue={show => !show && onClose()}
      slotFooter={<Button onClick={onClose}>{_$('关闭')}</Button>}
    >
      <div className={className}>
        <Table
          data={versionList || []}
          loading={loading}
          animation={false}
          rowKey={record => record.ID}
          checkType="none"
        >
          <TableColumn key="ID" title="ID" width="80" />
          <TableColumn
            key="Creator"
            title={_$('操作人')}
            width="120"
            slotTemplate={([record]) => (record.Creator ? <UserInfo name={record.Creator} /> : '-')}
          />
          <TableColumn
            key="CreatedAt"
            title={_$('创建时间')}
            width="180"
            slotTemplate={([record]) => {
              if (!record.CreatedAt) return '-'
              return formatDate(record.CreatedAt, 'YYYY-MM-DD HH:mm:ss')
            }}
          />
          <TableColumn
            key="PublishedAt"
            title={_$('发布时间')}
            width="180"
            slotTemplate={([record]) => {
              if (!record.PublishedAt) return '-'
              return formatDate(record.PublishedAt, 'YYYY-MM-DD HH:mm:ss')
            }}
          />
          <TableColumn key="Version" title={_$('版本')} width="120" />
          <TableColumn
            key="VersionRemark"
            title={_$('版本说明')}
            width="200"
            slotTemplate={([record]) => (
              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {record.VersionRemark || '-'}
              </div>
            )}
          />
          <TableColumn
            key="Remark"
            title={_$('备注')}
            width="200"
            slotTemplate={([record]) => record.Remark || '-'}
          />
          <TableColumn
            key="Status"
            title={_$('状态')}
            width="120"
            slotTemplate={([record]) => renderFunctionStatus(record.Status, record.Approving)}
          />
          <TableColumn
            key="operations"
            title={_$('操作')}
            width="150"
            slotTemplate={([record]) => {
              return (
                <a onClick={() => history.push(`/monitor/eventops/functions/detail/${record.ID}`)}>
                  {_$('查看')}
                </a>
              )
            }}
          />
        </Table>
      </div>
    </Drawer>
  )
}

export default styled(VersionHistory)`
  .status-tag {
    display: inline-flex;
    align-items: center;
    border-radius: 4px;
    padding: 2px 8px;
    .k-icon {
      margin-right: 4px;
    }
  }
  .status-enabled {
    color: #1890ff;
    border-color: #91d5ff;
    background-color: #e6f7ff;
    .k-icon {
      color: #1890ff;
    }
  }
  .status-approving {
    color: #13c2c2;
    border-color: #13c2c2;
    background-color: #e6fffb;
    .k-icon {
      color: #13c2c2;
    }
  }
  .status-draft {
    color: #262626;
    border-color: #d9d9d9;
    background-color: #fff;
    .k-icon {
      color: #262626;
    }
  }
  .status-disabled {
    color: #ff4d4f;
    border-color: #ffccc7;
    background-color: #fff;
    .k-icon {
      color: #ff4d4f;
    }
  }
  .status-icon-spin {
    animation: spin 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    display: inline-block;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
